import React from 'react';

import { SxProps } from '@material-ui/system';
import Box from '@mui/material/Box';

import { appGridLgBreakpoint, appGridMdBreakpoint, appGridSmBreakpoint } from '~components/theme/breakpoints';

interface Props {
  children: React.ReactNode;
  sx?: SxProps;
}

const AppGrid = ({ children, sx }: Props) => (
  <Box
    sx={{
      minHeight: `calc(100% - 144px)`,
      scrollbarWidth: 'none',
      padding: ['48px 24px', '64px'],
      maxWidth: [appGridSmBreakpoint, appGridMdBreakpoint, appGridLgBreakpoint],
      margin: 'auto',
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default AppGrid;
